import { useState, useEffect } from "react";
import axios from "axios";
import Cookies from "universal-cookie";

const useFetch = (url) => {
  const [isFetching, setIsFetching] = useState(true);
  const [initialData, setInitialData] = useState(null);
  const [error, setError] = useState(null);
  const cookies = new Cookies().get("jes");

  const BASEURL = process.env.REACT_APP_BASEURL;
  const CONFIG = {
    headers: {
      Authorization: `Bearer ${cookies}`,
    },
  };

  useEffect(() => {
    if (!url) return;
    setIsFetching(true);

    axios
      .get(BASEURL + url, CONFIG)
      .then((res) => {
        setInitialData(res.data);
      })
      .catch((e) => {
        setError(e.response ? e.response.data.message : e);
      })
      .finally(() => {
        setIsFetching(false);
      });
  }, [url]);

  const get = (url, token = null) => {
    setIsFetching(true);
    return new Promise((resolve, reject) => {
      axios
        .get(
          BASEURL + url,
          token
            ? {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            : CONFIG
        )
        .then((res) => {
          resolve(res.data);
        })
        .catch((e) => {
          reject(e.response ? e.response.data : e);
        })
        .finally(() => {
          setIsFetching(false);
        });
    });
  };

  const put = (url, body) => {
    setIsFetching(true);

    return new Promise((resolve, reject) => {
      axios
        .put(BASEURL + url, body, CONFIG)
        .then((res) => {
          setIsFetching(false);
          resolve(res.data);
        })
        .catch((e) => {
          setIsFetching(false);
          reject(e.response ? e.response.data : e);
        });
    });
  };

  const patch = (url, body) => {
    setIsFetching(true);

    return new Promise((resolve, reject) => {
      axios
        .patch(BASEURL + url, body, CONFIG)
        .then((res) => {
          setIsFetching(false);
          resolve(res.data);
        })
        .catch((e) => {
          setIsFetching(false);
          reject(e.response ? e.response.data : e);
        });
    });
  };

  const del = (url) => {
    setIsFetching(true);

    return new Promise((resolve, reject) => {
      axios
        .delete(BASEURL + url, CONFIG)
        .then((res) => {
          setIsFetching(false);
          resolve(res.data);
        })
        .catch((e) => {
          setIsFetching(false);
          reject(e.response ? e.response.data : e);
        });
    });
  };

  const post = (url, body) => {
    setIsFetching(true);

    return new Promise((resolve, reject) => {
      axios
        .post(BASEURL + url, body, CONFIG)
        .then((res) => {
          setIsFetching(false);
          resolve(res.data);
        })
        .catch((e) => {
          setIsFetching(false);
          reject(e.response ? e.response.data : e);
        });
    });
  };

  return { get, put, del, post, patch, isFetching, initialData, error };
};

export default useFetch;
